import React from 'react';
import { useNavigate } from 'react-router-dom';
import ContactUs from './Contactus';
import { ArrowRight } from "lucide-react";

// const HeroSection = () => {
//   return (
//     <section className="hero-section">
      
//       {/* Background Image */}
//       <div className="hero-bg-overlay"></div>

//       {/* Navbar spacing */}
//       <div className="hero-content-wrapper">

//         {/* Left Content */}
//         <div className="hero-content">
//           <h1 className="hero-heading">
//             Helping <span>United Kingdom businesses scale</span> with reliable
//             digital solutions
//           </h1>

//           <button className="hero-btn">
//             Get in Touch <ArrowRight size={18} />
//           </button>
//         </div>

//         {/* Bottom Floating Card */}
//         <div className="impact-card">

//           <div className="impact-top-content">
//             <div>
//               <h2>
//                 Impact <br />
//                 Starts Here
//               </h2>
//             </div>

//             <p>
//               By combining user-centric design with advanced technology, we
//               create solutions that not only look great — but deliver real,
//               measurable impact.
//             </p>
//           </div>

//           <div className="impact-stats">

//             <div className="impact-item">
//               <h3>UK Registered</h3>
//               <p>Companies House certified</p>
//             </div>

//             <div className="impact-item">
//               <h3>GMT Support</h3>
//               <p>UK timezone availability</p>
//             </div>

//             <div className="impact-item">
//               <h3>ISO Certified</h3>
//               <p>Quality assured delivery</p>
//             </div>

//             <div className="impact-item">
//               <h3>50+ Clients</h3>
//               <p>Across UK and Europe</p>
//             </div>

//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default HeroSection;
const LandingPage = () => {
  return (
    <div className="main-container">
      {/* SECTION 1: HERO SECTION */}
      <section className="hero-section">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Custom Software &<span> Digital Solutions </span>for Modern Businesses</h1>
            <p>We help businesses build scalable website, SaaS platform and software solutions that improve efficiency, enhance user experience and drive growth.</p>
            <button className="cta-button">Book a Free Consultation<span>→</span></button>
          </div>
        </div>

        {/* IMPACT CARD (The Floating Blue/Green Bar) */}
        <div className="impact-container">
          <div className="impact-card">
            <div className="impact-left">
              <div className="impact-left-head">
              <h2>Impact Starts Here</h2>
              <hr className="impact-left-horizontal-line"></hr>
              </div>
              <p>By combining user-centric design with advanced technology, we create solutions that not only look great—but deliver real, measurable impact.</p>
            </div>
            <div className="impact-stats">
              <div className="stat-item">
                <span className="icon"><img src="Impactstat-1.svg"></img></span>
                <h3>Secure & Reliable</h3>
                <p>We build secure digital solutions you can rely on .</p>
              </div>
              <div className="stat-item">
                <span className="icon"><img src="Impactstat-2.svg"></img></span>
                <h3>Business Focused</h3>
                <p>We solve business problems by developing products that drive growth and create value.</p>
              </div>
              <div className="stat-item">
                <span className="icon"><img src="ISO-container.svg"></img></span>
                <h3>Modern Technology</h3>
                <p>Empowering businesses by building innovative, future-ready digital solutions.</p>
              </div>
              <div className="stat-item">
                <span className="icon"><img src="Clients-Container.svg"></img></span>
                <h3>Ongoing Support</h3>
                <p>With our ongoing support you can scale your business with confidence.</p>
              </div>
            </div>
          </div>
          {/* <img src="UK_ImpactSection.png"></img> */}
        </div>
      </section>

      {/* SECTION 2: TRANSFORMATION PARTNER SECTION */}
      <section className="partner-section">
        <div className="partner-header">
          <div className="header-left">
            <span className="sub-tag">Our Solution</span>
            <h2>Your One-Stop Digital Transformation Partner</h2>
             <hr className="partner-section-horizontal-line"></hr>
          </div>
          <div className="header-right">
            <p>By combining user-centric design with advanced technology, we create solutions that not only look great—but deliver real, measurable impact.</p>
          </div>
        </div>

        <div className="services-grid">
          {/* Card 1 */}
          <div className="service-card">
            <h3>Custom Software Development</h3>
            <p>Bespoke enterprise applications built with modern frameworks and scalable architecture.</p>
            <div className="card-img-placeholder code-img"><img src="Our-Solution-frame1.png"></img></div>
          </div>
          {/* Card 2 */}
          <div className="service-card">
            <h3>Digital Transformation</h3>
            <p>Modernize operations and assess efficiency with strategic digital initiatives.</p>
            <div className="card-img-placeholder device-img"><img src="Our-Solution-frame2.png"></img></div>
          </div>
          {/* Card 3 */}
          <div className="service-card">
            <h3>SaaS Development</h3>
            <p>Build and launch scalable SaaS products with subscription-ready architecture.</p>
            <div className="card-img-placeholder cloud-img"><img src="Our-Solution-frame3.png"></img></div>
          </div>
          {/* Card 4 */}
          <div className="service-card">
            <h3>UI/UX Design</h3>
            <p>User-centered design that converts visitors into loyal customers.</p>
            <div className="card-img-placeholder design-img"><img src="Our-Solution-frame4.png"></img></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;